import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const initialState = { icon: '', text: '', color: '' };

const NOTIFICATION_DELAY = 3000;

export const useNotification = () => {
  const [status, setStatus] = useState(initialState);

  const handleStatus = (icon, text, color) => {
    setStatus({ icon, text, color });
  };

  useEffect(() => {
    if (!status.text.length) return undefined;
    const timeout = setTimeout(() => setStatus(initialState), NOTIFICATION_DELAY);
    return () => clearTimeout(timeout);
  }, [status]);

  return [status, handleStatus];
};

const Notification = ({ color, text, icon }) => (
  <p className={`font-americaMonoRegular text-xs uppercase m-0 text-${color}`}>
    <span className={`font-icon ${icon} mr-2`} />
    {text}
  </p>
);

Notification.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
};
Notification.defaultProps = {
  text: '',
  color: '',
  icon: '',
};

export default Notification;
